import { BaseQueryOptions } from '@apollo/client'
import { graphql, ChildProps } from '@apollo/client/react/hoc'
import { RouteComponentProps } from 'react-router-dom'
import getCountry from '../../helpers/get-country'
import { ApplicationError } from '../../helpers/errors'
import { Variables, Response, Props } from './types'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({
  staticContext,
}: RouteComponentProps): BaseQueryOptions<Variables> => ({
  variables: { country: getCountry(staticContext) },
  errorPolicy: 'ignore',
  fetchPolicy: 'no-cache',
  context: { version: 2 },
})

export const mapDataToProps = ({
  data,
}: Response): ChildProps<Props, Response, Variables> => {
  if (!data) {
    return { error: new ApplicationError('No data') }
  }
  const { error, loading, cfNationalHomepageCollection } = data
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }
  const { navigationMenu } = cfNationalHomepageCollection.items[0]
  return { nationalNavLinks: { navigationMenu } }
}

const withNationalNavLinks = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withNationalNavLinks
